import { Flex, Input, List } from "antd";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { CustomTitle } from "../../../components";
import { ChevronRightIcon, SearchIcon } from "../../../assets/icons/icons";
// import airportjson from "../airportjson.json";
import airportjson2 from "../airportjson2.json";
import airportjson from "../countryAirport.json";

const AirportList = () => {
  const [airportData, setAirportData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");


  // Convert object to array & store it in state initially
  useEffect(() => {
    const formattedData = Object.entries(airportjson)
      .filter(([_, details]) => details?.IATA) // Exclude entries with empty IATA
      .map(([code, details]) => ({
        code: details?.IATA,
        name: `${details?.City} (${details?.IATA})`, // ✅ Correctly formats Name (Code)
        ...details,
      }));
  
    setAirportData(formattedData);
  }, []);
  

  // Filter airports otherwise show all
  const displayedAirports =
  searchTerm.trim() === ""
    ? airportData
    : airportData.filter(
        (airport) =>
          airport?.IATA?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          airport?.City?.toLowerCase().includes(searchTerm.toLowerCase()) // ✅ Allows searching by both Name & Code
      );
        // const data = [
        //   { name: "Los Angeles International Airport (LAX)", code: "LAX" },
        //   { name: "San Francisco International Airport (SFO)", code: "SFO" },
        //   { name: "John F. Kennedy International Airport (JFK)", code: "JFK" },
        //   { name: "O'Hare International Airport (ORD)", code: "ORD" },
        //   { name: "Logan International Airport (BOS)", code: "BOS" },
        //   { name: "Dallas Fort Worth International Airport (DFW)", code: "DFW" },
        // ];

  return (
    <section className="airport-list">
      <Flex vertical gap={20}>
        <CustomTitle
          className="zl-custom-title"
          text="Airports"
          fontSize="28px"
          fontWeight={700}
          lineHeight="36px"
          marginBottom="0"
        />
        <Flex vertical gap={1}>
          <Flex vertical gap={20}>
            <Input
              className="zl-search"
              placeholder="Search for an airport..."
              prefix={<SearchIcon fill="black" width={12} height={12} />}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <CustomTitle
              text="Most searched"
              fontSize="12px"
              fontWeight={600}
              lineHeight="16px"
              color="#5E5E5E"
            />
          </Flex>
          <List
            className="zl-airport-list"
            dataSource={displayedAirports}
            renderItem={(item) => (
              <List.Item>
                <Link
                  to={`/airport/${item.code}`}
                  state={{ airport: item }}
                  style={{
                    width: "100%",
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  <Flex align="center" justify="space-between" style={{ width: "100%" }}>
                    <span>{item.name}  </span>
                    <ChevronRightIcon fill="#5E5E5E" width={24} height={24} />
                  </Flex>
                </Link>
              </List.Item>
            )}
          />
        </Flex>
      </Flex>
    </section>
  );
};

export default AirportList;
